import { createAxiosInstance } from '@servicetitan/cp-api';

const axiosInstance = createAxiosInstance();

export interface MfaVerificationRequest {
    mfaSessionToken: string;
    code: string;
    keepSigned: boolean;
}

export interface ResendMfaCodeRequest {
    mfaSessionToken: string;
}

export interface ResendMfaCodeResponse {
    mfaSessionToken: string;
}

export async function verifyMfaCode(request: MfaVerificationRequest): Promise<void> {
    await axiosInstance.post('/api/cp/users/authenticate/mfa', request);
}

export async function resendMfaCode(request: ResendMfaCodeRequest): Promise<ResendMfaCodeResponse> {
    const response = await axiosInstance.post<ResendMfaCodeResponse>(
        '/api/cp/users/authenticate/mfa/resend',
        request
    );
    return response.data;
}
